import _compact from "lodash/compact";
import _join from "lodash/join";
import { IAgency } from "models";

export const getAgentAddress = (agent: IAgency) => {
  return _join(
    _compact([
      agent.address?.addressLine1,
      agent.address?.addressLine2,
      agent.address?.addressLine3,
      agent.address?.addressLine4,
      agent.address?.country,
      agent.address?.postCode,
    ]),
    ", "
  );
};

export const getAgentPhones = (agent: IAgency) => {
  return _join(
    _compact(
      [
        agent.phone,
        agent.phone2,
        agent.phone3,
        agent.phone4,
        agent.mobilePhone,
        agent.mobilePhone2,
      ].map((num) => num?.trim())
    ),
    ", "
  );
};
